module.exports = __webpack_public_path__ + "img/checkout-successfull.1bab7ec.webp";